import { useNavigate, useLocation } from "react-router-dom";
import {
  BarChart3,
  CalendarDays,
  Caravan,
  Archive as ArchiveIcon,
  ClipboardCheck,
  Home,
  LogOut,
  WalletCards,
  Users,
  TriangleAlert
} from "lucide-react";

export default function Sidebar({ onLogout }) {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { path: "/dashboard", label: "Dashboard", icon: BarChart3 },
    { path: "/reservations", label: "Reservaties", icon: CalendarDays },
    { path: "/admin/checkouts", label: "Check-outs", icon: ClipboardCheck },
    { path: "/admin/checkins", label: "Check-ins", icon: ClipboardCheck },
    { path: "/admin/settlements", label: "Waarborgen", icon: WalletCards },
    { path: "/trailers", label: "Trailers", icon: Caravan },
    { path: "/customers", label: "Klanten", icon: Users },
    { path: "/damage", label: "Schadegevallen", icon: TriangleAlert },
    { path: "/archive", label: "Archief", icon: ArchiveIcon },
    { path: "/", label: "Homepagina", icon: Home }
  ];

  return (
    <aside className="sidebar">
      <div className="sidebar-brand">
        <p className="sidebar-brand-title">DR-Renting</p>
      </div>

      <nav className="sidebar-nav">
        {navItems.map((item) => {
          const Icon = item.icon;

          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={`sidebar-button${location.pathname === item.path ? " active" : ""}`}
            >
              <Icon size={18} />
              {item.label}
            </button>
          );
        })}
      </nav>

      <button onClick={onLogout} className="sidebar-button danger">
        <LogOut size={18} />
        Afmelden
      </button>
    </aside>
  );
}
